import { Component, Input, Output, EventEmitter } from '@angular/core';


@Component({
  moduleId: module.id,
  selector: 'generic-pagination',
  templateUrl: 'generic-pagination.component.html',
  styleUrls: ['generic-pagination.component.scss'],
})

export class GenericPaginationComponent {

  @Output() pageChanged = new EventEmitter();

  @Output() itemsPerPageChanged = new EventEmitter();

  @Input() perNumbers: number[] = [
    25,
    50,
    100,
  ];

  @Input() page: number = 1;

  @Input() per: number = 25;

  @Input() total: number = 0;

  @Input() lastPage: number = 0;

  @Input() disabled: boolean = false;

  @Input() dropdown: boolean = true;

  @Input() perName: string = 'page';

  // ['numbering-right', ...]
  @Input() style: string = '';

  @Input() dropup: boolean = false;

  @Input() version2: boolean = false;

  get totalFormatted(): string {
    return String(this.total);
  }

  get startRange(): number {
    if (this.page === 1) { return 1; }
    return ((this.page - 1) * this.per) + 1;
  }

  get endRange(): number {
    let endRange = this.total;
    if (this.per < this.total) {
      endRange = this.page * this.per;
      if (endRange > this.total) { return this.total; }
    }
    return endRange;
  }

  get isPrevDisabled(): boolean {
    return this.page === 1;
  }

  get isNextDisabled(): boolean {
    return this.endRange >= this.total;
  }

  changeItemsPerPage(itemsPerPage: number) {
    this.per = itemsPerPage;
    this.itemsPerPageChanged.emit(itemsPerPage);
  }

  changePage(direction: number) {
    if (direction === 1 && this.isNextDisabled) { return; }
    if (direction === -1 && this.isPrevDisabled) { return; }
    this.page += direction;
    this.pageChanged.emit(this.page);
  }

}
